import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-1 text-left text-xs text-red-600" }


import ToggleSwitch from 'primevue/toggleswitch';


export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultToggleSwitch',
  props: {
    error: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["text-bluegray-600 block flex-1 text-left text-sm font-normal", _ctx.$attrs.class])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(ToggleSwitch), _mergeProps(_ctx.$attrs, {
      class: "mt-1 !block",
      size: "small",
      invalid: !!_ctx.error
    }), null, 16, ["invalid"]),
    _createElementVNode("small", _hoisted_1, _toDisplayString(_ctx.error), 1)
  ], 2))
}
}

})